import React from 'react'
// views
import { ColumnsWrapper, ColumnWrapper } from './views'
import { AddButton, CloseIcon } from 'components/Modals/LookupFilterModal/components/Form/components/Rules/views'
// components
import Sources from './compoennts/Sources'
import { ReduxInput } from 'components/FormElements'
// types
import { FieldArray } from 'redux-form'
import { WrappedFieldArrayProps } from 'redux-form/lib/FieldArray'
// utils
import { required } from 'utils/validators'

const Column = ({ field, remove }) => {
  return (
    <ColumnWrapper>
      <CloseIcon onClick={remove} />
      <ReduxInput label='Name' name={`${field}.name`} validate={required} />
      <FieldArray<any> name={`${field}.sources`} component={Sources} />
    </ColumnWrapper>
  )
}

const Columns: React.FC<WrappedFieldArrayProps> = ({ fields }) => {
  const addRule = () => fields.push({})

  const removeRule = (idx: number) => () => fields.remove(idx)

  return (
    <ColumnsWrapper>
      {fields.map((field, idx) => (
        <Column key={field} field={field} remove={removeRule(idx)} />
      ))}
      <AddButton onClick={addRule}>+ Add Column</AddButton>
    </ColumnsWrapper>
  )
}

export default Columns
